import { getToken } from './tokenAccess';
import { isAdminToken } from './claims';

/**
 * Reads the administrator claim from the current access token.
 * Token changes do not trigger re-render; this is read at guard/render time,
 * which is sufficient for gating admin UI on navigation.
 */
export function useIsAdmin(): boolean {
  return isAdminToken(getToken());
}
